import { SlotGameType1_21 } from '../SlotGameType1_21';

export class MundoMistico21 extends SlotGameType1_21
{
}
